export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إلغاء"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نعم"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["هل أنت متأكد من أنك تريد المتابعة؟"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حذف الأصول المشفرة"])}
}